import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=704d40cf&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('704d40cf')) {
      api.createRecord('704d40cf', component.options)
    } else {
      api.reload('704d40cf', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=704d40cf&", function () {
      api.rerender('704d40cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27RGGljQP5bDY/JS/offershelp.vue"
export default component.exports